import { type Node, type NodeProps, Position } from '@xyflow/react';
import React from 'react';

import { createHandleId } from '../../utils/handle-ids';
import { BaseNode, type NodeData } from './BaseNode';
import { NodeHandle } from './NodeHandle';

export type JsonTemplateNodeType = Node<NodeData, 'custom_json_template'>;

export const JsonTemplateNode: React.FC<NodeProps<JsonTemplateNodeType>> = ({
  id,
  data,
  selected,
}) => {
  const config = data.config as Record<string, unknown>;
  const hasTemplate = config.template !== undefined;
  const subtitle = hasTemplate
    ? 'JSON Template'
    : 'JSON Template (no template)';

  // Extract connection state from node data for visual indicators
  const activeConnection = data.activeConnection;
  const isValidTargetHandle = data.isValidTargetHandle as
    | ((targetHandle: string) => boolean)
    | undefined;
  const isActiveConnection = !!activeConnection;

  return (
    <BaseNode
      nodeId={id}
      data={data}
      category="transform"
      subtitle={subtitle}
      selected={selected}
    >
      {/* Input handle for template data */}
      <NodeHandle
        type="target"
        position={Position.Left}
        id="data"
        blockId={id}
        isActiveConnection={isActiveConnection}
        isValidTarget={
          isValidTargetHandle
            ? isValidTargetHandle(createHandleId(id, 'data'))
            : undefined
        }
      />
      {/* Output handle for results */}
      <NodeHandle
        type="source"
        position={Position.Right}
        id="result"
        blockId={id}
        isActiveConnection={isActiveConnection}
      />
    </BaseNode>
  );
};
